import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from 'vant'
import 'vant/lib/index.css'
import VueLuckyCanvas from '@lucky-canvas/vue'
import { registerServiceWorker } from '@/utils/registerServiceWorker'
import { consumeTokenFromUrl } from '@/utils/tokenLogin'
import { getToken, removeUserInfo } from '@/utils/auth'
import { clearApiCache } from '@/utils/apiCache'

async function initApp() {
   // 后台一键登录：先消费 ?token=，再挂载路由，避免被踢回登录页
   const usedAdminLoginLink = consumeTokenFromUrl()
   const token = getToken()
   if (token) {
      store.commit('user/SET_TOKEN', token)
      if (usedAdminLoginLink) {
         clearApiCache()
         removeUserInfo()
         store.commit('user/SET_USER_INFO', null)
      }
   }

   const app = createApp(App)

   try {
      app.use(router)
         .use(store)
         .use(vant)
         .use(VueLuckyCanvas)

      app.mount('#app')

      store.dispatch('config/bootstrapWebViewConfig')

      registerServiceWorker()
   } catch (error) {
      console.error('应用初始化失败:', error)
   }
}

initApp()